/* eslint-disable no-console */
import axios from "axios";
import { Toast } from "vant";
import { stringify } from "querystring";

//axios.defaults.timeout = 30000; // 响应时间
 //axios.defaults.headers.post["Content-Type"] ='application/json;charset=UTF-8'
//   "application/json;charset=UTF-8"; // 配置请求头
//axios.defaults.baseURL='http://192.168.1.196:8099/api'
//axios.defaults.baseURL = '/api'
//axios.defaults.baseURL = apiConfig.baseUrl;// 配置接口地址
let urlHost = process.env.API_HOST
axios.defaults.baseURL=urlHost;
axios.defaults.timeout=120000;
axios.defaults.withCredentials=false;
var loaddingcount = 0;
// POST传参序列化(添加请求拦截器)
axios.interceptors.request.use(
  config => {
    // 在发送请求之前做某件事
    if (config.method === "post") {
      // config.data = qs.stringify(config.data)
      //  config.headers['Content-Type'] = 'application/json;charset=UTF-8'
    }
     config.headers["WxAuthorization"] = localStorage.getItem("token");
    // console.log("wxauthor="+config.headers["WxAuthorization"])
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration:50000
      });
    if (loaddingcount <= 0) {
      loaddingcount = 0;
    }
    loaddingcount++;
    return config;
  },
  error => {
    console.log("错误的传参");
    loaddingcount -= 1;
    if (loaddingcount <= 0) {
      Toast.clear();
      //Mint.Indicator.close(); // 关闭loading
    }
    return Promise.reject(error);
  }
);

// 返回状态判断(添加响应拦截器)
axios.interceptors.response.use(
  res => {
    loaddingcount--;
    if (loaddingcount <= 0) {
     // Mint.Indicator.close(); // 关闭loading
     Toast.clear();
     //Toast.fail("网络超时,请重新刷新页面")
    }
    //console.log(res)
    // 对响应数据做些事
    if (res.data.Status =="success") {
      //如果返回错误代码则提示
      return Promise.resolve(res.data);
    }
    if (res.data.Status =="error") { 
      Toast(res.data.Message);
    }
    return res.data;
  },
  error => { 
    loaddingcount--;
    if (loaddingcount <= 0) {
      Toast.clear();
      //console.log(loaddingcount)
      //Mint.Indicator.close(); // 关闭loading
    }
    console.log("网络异常");
    Toast.fail("加载失败 ");
    return Promise.reject(error);
  }
);




// 返回一个Promise(发送post请求)
export function Post(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then(
        response => {
          resolve(response);
        },
        err => {
          reject(err);
        }
      )
      .catch(error => {
        reject(error);
      });
  });
}
// 返回一个Promise(发送get请求)
export function Get(url, param) {
  return new Promise((resolve, reject) => {
    axios
      .get(url   + "?" + stringify(param))
      .then(
        response => {
          resolve(response);
        },
        err => {
          reject(err);
        }
      )
      .catch(error => {
        reject(error);
      });
  });
}


export function httpRequest(paramObj, fun, errFun) {
  var xmlhttp = null
  /* 创建XMLHttpRequest对象，
     *老版本的 Internet Explorer（IE5 和 IE6）使用 ActiveX 对象：new ActiveXObject("Microsoft.XMLHTTP")
     * */
  if (window.XMLHttpRequest) {
    xmlhttp = new XMLHttpRequest()
  } else if (window.ActiveXObject) {
    xmlhttp = new ActiveXObject('Microsoft.XMLHTTP')
  }
  
  /* 判断是否支持请求*/
  if (xmlhttp == null) {
    Toast('你的浏览器不支持XMLHttp')
    return
  }
  
  /* 请求方式，并且转换为大写*/
  var httpType = (paramObj.type || 'GET').toUpperCase()
  /* 数据类型*/
  // var dataType = paramObj.dataType || 'json'
  /* 请求接口*/
  var httpUrl = paramObj.httpUrl || ''
  /* 是否异步请求*/
  var async = paramObj.async || true
  /* 请求参数--post请求参数格式为：foo=bar&lorem=ipsum*/
  var paramData = paramObj.data || []
  var requestData = ''
  for (var name in paramData) {
    requestData += name + '=' + paramData[name] + '&'
  }
  requestData = requestData === '' ? '' : requestData.substring(0, requestData.length - 1)
  console.log(requestData)
  /* 请求接收*/
  xmlhttp.onreadystatechange = function() {
    if (xmlhttp.readyState === 4 && xmlhttp.status === 200) {
      /* 成功回调函数*/
      fun(xmlhttp.responseText)
    } else {
    /* 失败回调函数*/
      errFun
    }
  }
  /* 接口连接，先判断连接类型是post还是get*/
  if (httpType === 'GET') {
    xmlhttp.open('GET', httpUrl, async)
    xmlhttp.setRequestHeader("WxAuthorization", localStorage.getItem("token"))
    xmlhttp.send(null)
  } else if (httpType === 'POST') {
    xmlhttp.open('POST', httpUrl, async)
    // 发送合适的请求头信息
    
  xmlhttp.setRequestHeader("WxAuthorization",localStorage.getItem("token"));
  xmlhttp.setRequestHeader('Content-Type','application/x-www-form-urlencoded');
    xmlhttp.send(requestData)
  }
}

export default {
  Post,
  Get,
  httpRequest
};



// WEBPACK FOOTER //
// ./src/utils/https.js